import React, { useEffect, useState, createContext } from "react";
import loadmap from "./loadmap";
export const MapContext = createContext();
export default ({
  minZoom = 8,
  pitch = 24,
  center = [112.21, 31.03],
  onCreate = () => {},
  onZoom = () => {},
  mapStyle = "amap://styles/f501ba8f400dd470a469c479dd83bccb",
  showControl = false,
  rotation = 0,
  children,
}) => {
  const [map$$, setmap$$] = useState(null);
  useEffect(() => {
    const create = () => {
      let map = new window.AMap.Map("tui-amap-container", {
        rotateEnable: true,
        doubleClickZoom: false,
        pitchEnable: true,
        zoom: minZoom,
        center: center,
        pitch: pitch,
        zooms: [6, 20],
        viewMode: "3D",
        mapStyle: mapStyle,
        skyColor: "rgb(0,0,0)",
        rotation: rotation,
        resizeEnable: true,
        doubleClickZoom: false,
      });

      showControl &&
        map.plugin(["AMap.ControlBar"], function () {
          let options = {
            position: { left: "-100px", bottom: "-16px" },
            showZoomBar: false,
            showControlButton: true,
          };
          var controlBar = new window.AMap.ControlBar(options);
          map.addControl(controlBar);
        });

      onCreate(map);

      map.on("zoomend", () => {
        const zoom = map.getZoom();
        let degree = 1;
        if (zoom <= 10) degree = 1;
        if (zoom > 10 && zoom < 14) degree = 2;
        if (zoom >= 14) degree = 3;
        onZoom(degree);
      });
      setmap$$(map);
    };
    loadmap(create);
  }, []);

  return (
    <div
      id="tui-amap-container"
      style={{ height: "100%", backgroundColor: "rgb(0, 7, 14)" }}
    >
      <MapContext.Provider value={map$$}>{children}</MapContext.Provider>
    </div>
  );
};
